module.exports = ".upload-btn {\r\n  margin: 10px;\r\n}\r\n"